module.exports = __webpack_public_path__ + "static/media/rogue-icon.ccedb8ad.png";